/**
 * Rhumatologie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: RHUM
 * Catalogue acts (NGAP Maroc): 0
 */
import { defineSpecialty } from "../types";

export const rhumatologie = defineSpecialty(
{
  "id": "rhumatologie",
  "label": "Rhumatologie",
  "short": "rhumatologie",
  "scope": "Pathologies articulaires, inflammatoires, auto-immunes et ostéoporose",
  "aliases": [
    "RHUM"
  ],
  "doctorSpecs": [
    "Rhumatologie"
  ],
  "featureFlag": "ux.v2.rhumatologie",
  "theme": {
    "primary": "oklch(0.68 0.13 40)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "lab",
      "label": "Laboratoire",
      "icon": "FlaskConical",
      "route": "/clinical/lab",
      "order": 2,
      "requires": [
        "lims"
      ]
    },
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "route": "/clinical/imaging",
      "order": 3,
      "requires": [
        "imaging"
      ]
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "joints",
      "label": "Articulations",
      "icon": "Bone",
      "component": "JointAssessmentPanel",
      "order": 1,
      "requires": []
    },
    {
      "id": "labs",
      "label": "Bilan",
      "icon": "FlaskConical",
      "component": "LabResultsGrid",
      "order": 2,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Rhumatologie",
    "subSpecialties": [
      "Consultation",
      "Ponction articulaire",
      "Biologie"
    ],
    "catalogueActs": 0
  },
  "terminology": {
    "icd10": [
      "M05",
      "M15",
      "M32",
      "M54",
      "M81"
    ],
    "loinc": [
      "30341-2",
      "11572-5"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "ultrasound-msk",
    "xray-portable",
    "dexa-scanner"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default rhumatologie;
